/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ w: NonNullable<unknown> }} Water_Efr_ConsumptionInputs */



/**
* | output |
* | --- |
* | "Fill cold water: {w} m³" |
*
* @param {Water_Efr_ConsumptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const water_efr_consumption = /** @type {((inputs: Water_Efr_ConsumptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Water_Efr_ConsumptionInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Fill cold water: ${i?.w} m³`)
	return /** @type {LocalizedString} */ (`Eau froide de remplissage : ${i?.w} m³`)
});